import React from "react";
import NavBar from "../components/Nav";
import Banner from "../components/Banner";
import BackTop from "../components/BackToTop";
import Category from "../components/Category";
import Service from "../components/ServiceOffered";
import PropertyListing from "../components/Properties";
import Call from "../components/Call";
import Footer from "../components/Footer";
import GoToTop from "../components/Top";

function Home() {
  return (
    <>
      <div classNameName="container-fluid px-3">
        <title>RoyalMines Property</title>
        <meta
          name="description"
          content="Find the best real estate and properties in Abuja and Nigeria. Explore a wide range of residential and commercial properties, including houses, apartments, land, and more. Discover trusted real estate agents, listings, and resources to help you buy, sell, or rent properties in Abuja and across Nigeria."
        />
        <meta
          name="keywords"
          content="real estate, properties, Abuja, Nigeria, houses, apartments, land, mortgages, mortgage, real estate agents, listings, buy, sell, rent, residential, commercial, apartments, houses, land, real estate solutions, real estate company"
        />

        <NavBar home={"active"} />
        <Banner />
        <BackTop />

        {/* mission */}
        <section className="mission-section">
          <div className="container">
            <div className="row align-items-center g-4">
              <div className="col-lg-6 wow fadeInDown" data-wow-delay="0.1s">
                <span className="mission-eyebrow">Our mission</span>
                <h2 className="mission-title">
                  Building trust-forward real estate experiences across Nigeria.
                </h2>
                <p className="mission-lead">
                  We lead with clarity, speed, and accountability so every
                  client feels confident moving from search to keys.
                </p>
              </div>
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
                <div className="mission-card">
                  <div className="mission-pillars">
                    <div className="mission-pillar">
                      <span className="mission-pill">Trust</span>
                      <p>Transparent listings and vetted ownership history.</p>
                    </div>
                    <div className="mission-pillar">
                      <span className="mission-pill">Technology</span>
                      <p>Faster property discovery with smart guidance.</p>
                    </div>
                    <div className="mission-pillar">
                      <span className="mission-pill">Service</span>
                      <p>Dedicated advisors from first viewing to closing.</p>
                    </div>
                  </div>
                  <div className="mission-highlight">
                    <span>Guided by outcomes</span>
                    <strong>2,500+ families matched with homes</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div style={{ background: "whitesmoke" }}>
          <Category />
          <Service />
        </div>

        <div style={{ background: "white" }}>
          <PropertyListing />
          <Call />
        </div>

        <div>
          <Footer />
        </div>
      </div>
      <GoToTop />
    </>
  );
}

export default Home;
